module.exports = __webpack_public_path__ + "img/appTitle.02ba483b.png";